import React from 'react';
import { ApButtonIcon } from '@alixpartners/ui-components';
import { Backdrop, ModalNameContainer, ModalHeader } from './components.styles';

const ModuleNameModal = ({ children, onBack, onClose, title }) => {
	return (
		<Backdrop>
			<ModalNameContainer>
				<ModalHeader>
					<div style={{ flex: 1 }}>{title}&nbsp;</div>
					<ApButtonIcon
						title="Back"
						iconProps={{ material: true, iconName: 'arrow_back' }}
						onClick={onBack}
					/>
					<ApButtonIcon
						title="Close"
						iconName="close"
						onClick={() => onClose(false)}
					/>
				</ModalHeader>
				{children}
			</ModalNameContainer>
		</Backdrop>
	);
};

export default ModuleNameModal;
